import Switch, { SwitchProps } from "@mui/material/Switch";

export type { SwitchProps };

export default Switch;
